<template>
  <v-dialog v-model="show" width="80%" persistent>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-spacer/>
        <v-toolbar-title>{{$t('instructions.chooseAvatar')}}</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
      <v-card-text>
        <v-item-group v-model="avatarChoice">
          <v-container>
            <v-row>
              <v-col md="4" offset-md="2" sm="12" offset-sm="0">
                <v-item v-slot:default="{ active, toggle }">
                  <v-card
                    :color="active ? 'primary' : ''"
                    class="d-flex align-center"
                    height="300px"
                    @click="toggle"
                  >
                    <v-img
                      contain
                      height="100%"
                      v-if="!active"
                      src="@/assets/user/boy selection.png"
                    ></v-img>
                    <v-img contain height="100%" v-else src="@/assets/user/boy selected.png"></v-img>
                  </v-card>
                </v-item>
              </v-col>
              <v-col md="4" sm="12">
                <v-item v-slot:default="{ active, toggle }">
                  <v-card
                    :color="active ? 'primary' : ''"
                    class="d-flex align-center"
                    height="300px"
                    @click="toggle"
                  >
                    <v-img
                      contain
                      height="100%"
                      v-if="!active"
                      src="@/assets/user/girl selection.png"
                    ></v-img>
                    <v-img contain height="100%" v-else src="@/assets/user/girl selected.png"></v-img>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer/>
        <v-btn :loading="$store.getters['company/loading']" :disabled="(avatarChoice !== 0 && avatarChoice !== 1) || $store.getters['company/loading']" color="primary" @click="$emit('validation', avatarChoice)">{{$t('general.ok')}}</v-btn>
        <v-btn color="primary" text @click="$emit('cancel')">{{$t('general.previous')}}</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    avatarChoice: null
  })
};
</script>

<style>
</style>